import { z } from "zod";
import { DesignTokenOrigin, DesignTokenOriginPart, DesignTokenType, DesignTokenTypedData } from "../elements";
import { ImportModelBase, ImportModelInputBase } from "./base";

//
// Base
//

const DesignTokenImportModelPart = z.object({
  collectionId: z.string().optional(),
  codeSyntax: z.record(z.coerce.string()).optional(),
  scopes: z.array(z.string()).optional(),
});

export const DesignTokenImportModelBase = ImportModelBase.extend(DesignTokenImportModelPart.shape).extend({
  origin: DesignTokenOrigin,
});

export const DesignTokenImportModelInputBase = ImportModelInputBase.extend(DesignTokenImportModelPart.shape).extend({
  originMetadata: DesignTokenOriginPart,
});

//
// Import models
//

export const DesignTokenImportModel = DesignTokenTypedData.and(DesignTokenImportModelBase);
export const DesignTokenImportModelInput = DesignTokenTypedData.and(DesignTokenImportModelInputBase);

export type DesignTokenImportModelInputBase = z.infer<typeof DesignTokenImportModelInputBase>;

export type DesignTokenImportModel = z.infer<typeof DesignTokenImportModel>;
export type DesignTokenImportModelOfType<T extends DesignTokenType> = Extract<DesignTokenImportModel, { type: T }>;

export type DesignTokenImportModelInput = z.infer<typeof DesignTokenImportModelInput>;
export type DesignTokenImportModelInputOfType<T extends DesignTokenType> = Extract<DesignTokenImportModel, { type: T }>;

export function isDesignTokenImportModelOfType<T extends DesignTokenType>(
  designToken: DesignTokenImportModel,
  type: T
): designToken is DesignTokenImportModelOfType<T> {
  return designToken.type === type;
}

export function designTokenImportModelTypeFilter<T extends DesignTokenType>(
  type: T
): (designToken: DesignTokenImportModel) => designToken is DesignTokenImportModelOfType<T> {
  return (designToken): designToken is DesignTokenImportModelOfType<T> =>
    isDesignTokenImportModelOfType(designToken, type);
}
